module.exports = __webpack_public_path__ + "static/media/wn_1CoverIMG_3499.e9baf349.jpg";